<template>
  <p ref="root" class="whitespace-pre-line">
    <template v-for="(segment, i) in segments" :key="i">
      <!-- Hover handlers on the wrapper, so moving onto the tooltip keeps it open -->
      <span
        v-if="segment.reasons"
        class="relative"
        @pointerenter="(e) => e.pointerType === 'mouse' && (open = i)"
        @pointerleave="(e) => e.pointerType === 'mouse' && close(i)"
      >
        <button
          type="button"
          class="inline text-left underline decoration-dashed decoration-primary-400 underline-offset-4 cursor-help focus:outline-none focus-visible:bg-primary-400/20 rounded-sm"
          :class="open === i ? 'bg-primary-400/20' : ''"
          :aria-describedby="open === i ? `${uid}-${i}` : undefined"
          :aria-expanded="open === i"
          @focus="open = i"
          @blur="close(i)"
          @click="open = i"
          @keydown.esc="open = null"
        >{{ segment.text }}</button>
        <!-- pt-2 instead of a margin: no gap for the pointer to fall through -->
        <span
          v-if="open === i"
          :id="`${uid}-${i}`"
          role="tooltip"
          class="absolute left-0 top-full z-30 w-72 max-w-[80vw] pt-2"
        >
          <span class="flex flex-col gap-1 rounded-lg border border-gray-700 bg-gray-800 p-3 text-left shadow-lg">
            <span class="text-xs text-text-secondary">{{ $t('coach.annotated_advice.why') }}</span>
            <span v-for="(reason, r) in segment.reasons" :key="r" class="text-sm leading-5 text-text-primary font-normal">{{ reason }}</span>
          </span>
        </span>
      </span>
      <template v-else>{{ segment.text }}</template>
    </template>
  </p>
</template>

<script setup>
import {
  ref, useId, onMounted, onBeforeUnmount,
} from 'vue';

defineProps({
  // parseAnnotatedFeedback(...).segments
  segments: { type: Array, required: true },
});

// Opening never toggles: a click also focuses (and a tap also fires
// pointerenter), so a toggle would close what that just opened. Hover is
// mouse-only; blur, pointer-leave, Escape and any press outside close. The
// outside press is what closes it on iOS, where a tap never focuses a button.
const uid = useId();
const open = ref(null);
const root = ref(null);

function close(i) {
  if (open.value === i) open.value = null;
}

function onOutsidePress(e) {
  if (open.value !== null && !root.value?.contains(e.target)) open.value = null;
}

onMounted(() => document.addEventListener('pointerdown', onOutsidePress));
onBeforeUnmount(() => document.removeEventListener('pointerdown', onOutsidePress));
</script>
